import { StyleSheet } from "react-native";

import type { UiTheme } from "../theme";

// Styles for the grouped day panel under the intensity grid. Cards keep
// the preview idiom (surface + border, generous tap targets); the
// superset ordinal column and the right-aligned tabular summary give the
// reduced-vision glance: name left, prescription right, always text.
export function makeDayPanelStyles(theme: UiTheme) {
  const { palette: p, spacing: s, radius: r, typography: t } = theme;
  return StyleSheet.create({
    dayName: {
      color: p.ink,
      fontSize: t.sizes.base,
      fontWeight: "700",
      marginTop: s.s4,
      marginBottom: s.s2,
    },
    entryCard: {
      padding: s.s4,
      borderRadius: r.r3,
      borderWidth: 1,
      borderColor: p.border,
      backgroundColor: p.surface,
      gap: s.s2,
      marginBottom: s.s2,
    },
    entryCardSelected: {
      borderColor: p.brand500,
      borderWidth: 1.5,
    },
    memberRow: {
      flexDirection: "row",
      alignItems: "baseline",
      gap: s.s3,
      minHeight: 24,
    },
    memberOrdinal: {
      width: 24,
      color: p.brand500,
      fontSize: t.sizes.xs,
      fontWeight: "700",
      fontVariant: ["tabular-nums"],
    },
    memberName: {
      flex: 1,
      color: p.ink,
      fontSize: t.sizes.base,
      fontWeight: "600",
    },
    memberSummary: {
      color: p.ink2,
      fontSize: t.sizes.sm,
      fontVariant: ["tabular-nums"],
      textAlign: "right",
      flexShrink: 0,
    },
    weeksChip: {
      alignSelf: "flex-start",
      paddingHorizontal: s.s2,
      paddingVertical: 1,
      borderRadius: 999,
      borderWidth: 1,
      borderColor: p.border,
    },
    weeksChipText: {
      color: p.ink3,
      fontSize: t.sizes.xs,
      fontWeight: "600",
      fontVariant: ["tabular-nums"],
    },
    verbatimNote: {
      color: p.ink3,
      fontSize: t.sizes.xs,
      fontStyle: "italic",
    },
    emptyText: {
      color: p.ink3,
      fontSize: t.sizes.sm,
      fontStyle: "italic",
      marginTop: s.s2,
    },
    panelHint: {
      color: p.ink3,
      fontSize: t.sizes.xs,
      marginBottom: s.s2,
    },
    actionsBar: {
      flexDirection: "row",
      flexWrap: "wrap",
      gap: s.s2,
      marginTop: s.s2,
    },
    actionBtn: {
      minHeight: 44,
      paddingHorizontal: s.s4,
      borderRadius: r.r3,
      borderWidth: 1,
      borderColor: p.border,
      alignItems: "center",
      justifyContent: "center",
    },
    actionText: {
      color: p.ink,
      fontSize: t.sizes.sm,
      fontWeight: "600",
    },
    actionBtnDanger: { borderColor: p.danger },
    actionTextDanger: { color: p.danger },
  });
}
